const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const DEFAULT_AUTO_POST_THRESHOLD = 0;

export function emptyIngestionForm() {
  return {
    ap_history_months: null,
    po_min_open_value_usd: null,
    accrual_auto_post_threshold: DEFAULT_AUTO_POST_THRESHOLD,
    fx_rate_source: '',
    include_non_po_invoices: false,
    vendor_master_source: '',
    period_end_trigger: null,
    po_claim_grain: 0,
    subsidiaries_in_scope: [],
  };
}

export function formFromConfig(config) {
  if (!config) return emptyIngestionForm();
  return {
    ap_history_months: config.ap_history_months ?? null,
    po_min_open_value_usd: config.po_min_open_value_usd ?? null,
    accrual_auto_post_threshold: config.accrual_auto_post_threshold ?? DEFAULT_AUTO_POST_THRESHOLD,
    fx_rate_source: config.fx_rate_source || '',
    include_non_po_invoices: config.include_non_po_invoices === true,
    vendor_master_source: config.vendor_master_source || '',
    period_end_trigger: integerDays(config.period_end_trigger),
    po_claim_grain: Number(config.po_claim_grain) === 1 ? 1 : 0,
    subsidiaries_in_scope: (config.subsidiaries_in_scope || []).map((row) => ({ ...row })),
  };
}

export function formSnapshot(form) {
  return JSON.stringify(form);
}

function periodEnd(reference) {
  return new Date(reference.getFullYear(), reference.getMonth() + 1, 0);
}

function dayLabel(date) {
  const day = String(date.getDate()).padStart(2, '0');
  return `${day} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

export function previewFacets(facets, apHistoryMonths, reference = new Date()) {
  const end = periodEnd(reference);
  const closeLabel = `${MONTHS[end.getMonth()]} ${end.getFullYear()}`;
  const months = Number(apHistoryMonths);
  return (facets || []).map((facet) => {
    if (facet.key !== 'ap_postings') {
      return { ...facet, effective_window: `Period-end snapshot — ${dayLabel(end)}` };
    }
    if (!Number.isInteger(months) || months < 1) {
      return { ...facet, effective_window: 'Set ap_history_months to preview the window' };
    }
    const start = new Date(end.getFullYear(), end.getMonth() - (months - 1), 1);
    return {
      ...facet,
      effective_window: `Will pull transactions from ${dayLabel(start)} to ${dayLabel(end)} for a ${closeLabel} close.`,
    };
  });
}

export function thresholdZone(value) {
  const number = Number(value);
  if (Number.isNaN(number) || value === '' || value === null) return '';
  if (number < 0.5) return 'Most items escalated to review';
  if (number <= 0.85) return 'Balanced';
  return 'Most items auto-posted';
}

export function percentFromThreshold(value) {
  if (value === '' || value === null || value === undefined) return '';
  const number = Number(value);
  if (!Number.isFinite(number)) return '';
  return Math.round(number * 100);
}

export function thresholdFromPercent(raw) {
  if (raw === '' || raw === null || raw === undefined) return null;
  const percent = Number(raw);
  if (!Number.isFinite(percent)) return null;
  return Math.min(100, Math.max(0, percent)) / 100;
}

export function integerDays(value) {
  if (value === '' || value === null || value === undefined) return null;
  const number = Number(value);
  if (!Number.isInteger(number) || number < 0) return null;
  return number;
}

export function periodEndTriggerHint(days) {
  const number = Number(days);
  if (!Number.isInteger(number) || number < 0) return '';
  if (number === 0) return 'Triggers on the cycle end date (T).';
  if (number === 1) return 'Triggers 1 day before the cycle end (T − 1).';
  return `Triggers ${number} days before the cycle end (T − ${number}).`;
}
